import React from 'react';
import { createUseStyles, Text, Icon, useTheme } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotSidebarTabHeader');
const CopilotSidebarTabHeader = _ref => {
  let {
    title,
    onBack,
    sideComponent
  } = _ref;
  const classes = useStyles();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, onBack && /*#__PURE__*/React.createElement(Icon, {
    name: "arrowBack",
    onClick: onBack,
    size: "large",
    color: theme.colors.primary.black
  }), /*#__PURE__*/React.createElement(Text, {
    type: "h4"
  }, title)), sideComponent);
};
export default CopilotSidebarTabHeader;